import { useEffect, useState } from "react";
import { getAll, Amount } from "../actions/studensts";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "./Table/Pagination";
import Search from "./Table/Search";
import { exportToExcel } from "./exportToExcel";
import { FiDollarSign, FiTrendingUp, FiDownload, FiSearch } from "react-icons/fi";
import RevenueExportModal from "./RevenueExportModal";
import MainStudentTable from "./MainStudentTable";
import StudentDetailsModal from "./StudentDetailsModal";

function Main() {
  const { students, count } = useSelector((state) => state.students);
  const [page, setPage] = useState(1);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [search, setSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [dailyAmount, setDailyAmount] = useState(0);
  const [allAmount, setAllAmount] = useState(0);
  const [selectState, setSelectState] = useState("all");
  const [showRevenueModal, setShowRevenueModal] = useState(false);
  const [activeStudent, setActiveStudent] = useState(null);
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile")).value[0];

  const getSelectState = (state) => {
    let newSelected = selectState;
    newSelected = state;
    setSelectState(newSelected);
  };


const getDailyAmount = async () => {
  if (user.role === 'admin') {
    setLoading1(true);
    try {
      const res = await Amount();
      if (res && res.data) {
        setDailyAmount(res.data.daily_amount);
        setAllAmount(res.data.total_amount);
      }
    } catch (error) {
      console.error('Error fetching daily amount:', error);
    } finally {
      setLoading1(false);
    }
  }
};


  // clear students on mount
  useEffect(() => {
    dispatch({ type: "CLEAR" });
    setHasSearched(false);
  }, [dispatch]);

  // update students on search term changes (immediate, no debounce since button controls it)
  useEffect(() => {
    if (!hasSearched) return;
    if (search && search.length < 3) return;
    
    // Clear students on new search to prevent flickering
    dispatch({ type: "CLEAR" });
    setLoading(true);
    dispatch(getAll(page, search)).finally(() => setLoading(false));
  }, [search, dispatch, hasSearched]);

  // update students on page changes (immediate, don't clear for smooth pagination)
  useEffect(() => {
    if (!hasSearched) return;
    if (search && search.length < 3) return;
    
    setLoading(true);
    dispatch(getAll(page, search)).finally(() => setLoading(false));
  }, [page]);

  // disabled the next button if in last page
  useEffect(() => {
    getDailyAmount();
    if (page === count?.maxPage) {
      setNextDisabled(true);
    } else {
      setNextDisabled(false);
    }
  }, [count?.maxPage, page]);

  return (
    <div className="min-h-screen px-4 sm:px-8 py-6">

      {/* ── Page Header ── */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white tracking-tight">Main Page</h1>
        <p className="text-slate-400 text-sm mt-1">Search, manage and export student records</p>
      </div>

      {/* ── Stats Cards (admin only) ── */}
      {user.role === "admin" && (
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
          {/* Daily Amount */}
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-600 to-emerald-800 p-5 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-emerald-200 text-xs font-semibold uppercase tracking-widest">Today's Revenue</p>
                <p className="text-white text-3xl font-bold mt-1">
                  {loading1 ? (
                    <span className="inline-block w-16 h-7 bg-emerald-500 animate-pulse rounded" />
                  ) : (
                    dailyAmount 
                  )} USD
                </p>
              </div>
              <div className="bg-emerald-500/30 rounded-full p-3">
                <FiDollarSign className="text-white text-2xl" />
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-emerald-500/20 rounded-full" />
          </div>

          {/* Total Amount */}
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-blue-600 to-blue-800 p-5 shadow-lg">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-blue-200 text-xs font-semibold uppercase tracking-widest">Total Revenue</p>
                <p className="text-white text-3xl font-bold mt-1">
                  {loading1 ? (
                    <span className="inline-block w-16 h-7 bg-blue-500 animate-pulse rounded" />
                  ) : (
                    allAmount
                  )} USD
                </p>
              </div>
              <div className="bg-blue-500/30 rounded-full p-3">
                <FiTrendingUp className="text-white text-2xl" />
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-blue-500/20 rounded-full" />
          </div>

          {/* Export Revenue */}
          <div
            className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-amber-600 to-amber-800 p-5 shadow-lg cursor-pointer hover:from-amber-500 hover:to-amber-700 transition-all duration-200"
            onClick={() => setShowRevenueModal(true)}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-amber-200 text-xs font-semibold uppercase tracking-widest">Revenue Report</p>
                <p className="text-white text-lg font-bold mt-1">Export Sheet</p>
                <p className="text-amber-200/70 text-xs mt-0.5">Filter by date range</p>
              </div>
              <div className="bg-amber-500/30 rounded-full p-3">
                <FiDownload className="text-white text-2xl" />
              </div>
            </div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-amber-500/20 rounded-full" />
          </div>
        </div>
      )}

      {/* Revenue Export Modal */}
      {showRevenueModal && (
        <RevenueExportModal onClose={() => setShowRevenueModal(false)} />
      )}

      {activeStudent && (
        <StudentDetailsModal
          student={activeStudent}
          onClose={() => setActiveStudent(null)}
        />
      )}

      {/* ── Search & Export Bar ── */}
      <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm p-5 mb-6 shadow">
        <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-end">

          {/* Search */}
          <div className="flex-1 w-full">
            <label className="text-slate-400 text-xs font-semibold uppercase tracking-widest mb-2 block">
              <FiSearch className="inline mr-1" />Search Students
            </label>
            <Search
              setSearch={(val) => {
                if (val === "") {
                  dispatch({ type: "CLEAR" });
                  setHasSearched(false);
                } else {
                  setHasSearched(true);
                }
                setSearch(val);
              }}
              setPage={setPage}
            />
          </div>

          {/* Export */}
          {(user.role === "admin" || user.role === "auditor") && (
            <div className="flex items-end gap-2 shrink-0">
              <div>
                <label className="text-slate-400 text-xs font-semibold uppercase tracking-widest mb-2 block">
                  <FiDownload className="inline mr-1" />Export by State
                </label>
                <select
                  onChange={(e) => getSelectState(e.target.value)}
                  className="bg-slate-800 border border-slate-600 text-white text-sm rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  id="states"
                >
                  <option value="all">All</option>
                  <option value="auditing">Auditing</option>
                  <option value="auditing_pending">Auditing Pending</option>
                  <option value="invoice">Invoice</option>
                  <option value="invoice_wait">Invoice Wait</option>
                  <option value="another_invoice">Another Invoice</option>
                  <option value="request_edit">Request Edit</option>
                  <option value="score_validation">Score Validation</option>
                  <option value="score_request">Score Request</option>
                  <option value="score_pending">Score Pending</option>
                  <option value="mohe_validation">MOHE Validation</option>
                  <option value="mohe">MOHE</option>
                  <option value="done">Done</option>
                </select>
              </div>
              <button
                type="button"
                onClick={() => exportToExcel(selectState)}
                className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors duration-200 shadow"
              >
                <FiDownload /> Export
              </button>
            </div>
          )}
        </div>
      </div>

      {/* ── Results Area ── */}
      <div className="rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm shadow overflow-hidden">
        {!hasSearched ? (
          <div className="flex flex-col items-center justify-center py-24 text-slate-400">
            <FiSearch className="text-5xl mb-4 opacity-40" />
            <p className="text-lg font-medium">Enter a name or ID to search</p>
            <p className="text-sm mt-1 opacity-60">Minimum 3 characters required</p>
          </div>
        ) : loading ? (
          <div className="flex flex-col items-center justify-center py-24">
            <div className="animate-spin rounded-full h-14 w-14 border-b-4 border-indigo-500 mb-4" />
            <p className="text-slate-400 text-base">Loading records…</p>
          </div>
        ) : students && students.length > 0 ? (
          <div className="p-3">
            {/* <div className="mb-4 flex items-center justify-between rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-3">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-slate-400">Compact Directory</p>
                <p className="mt-1 text-sm text-slate-300">Focused identity columns with a dedicated details view for the full record.</p>
              </div>
              <div className="rounded-full border border-emerald-400/20 bg-emerald-500/10 px-3 py-1 text-xs font-semibold text-emerald-300">
                {students.length} result{students.length === 1 ? "" : "s"}
              </div>
            </div> */}

            <MainStudentTable students={students} onView={setActiveStudent} />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-24 text-slate-400">
            <p className="text-lg font-medium">No results found</p>
            <p className="text-sm mt-1 opacity-60">Try a different search term</p>
          </div>
        )}
      </div>

      {/* ── Pagination ── */}
      <div className="py-5">
        <Pagination
          page={page}
          setPage={setPage}
          maxPage={count?.maxPage}
          nextDisabled={nextDisabled}
        />
      </div>
    </div>
  );
}

export default Main;